import { render, staticRenderFns } from "./VineyardPage.vue?vue&type=template&id=5502f732&"
import script from "./VineyardPage.vue?vue&type=script&lang=js&"
export * from "./VineyardPage.vue?vue&type=script&lang=js&"
import style0 from "./VineyardPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports